import { Component, OnInit, NgZone } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthenticationService, UtilsService, CommunicationService } from '../../helpers/services';
import { GlobalEventsManager } from '../../helpers/guards';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { CookieService } from 'ngx-cookie';
import { KRONOS } from '../../app-constants';
import { Observable } from 'rxjs';
declare var $: any;
@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
    loginRequest: any = {};
    userData: any = [];
    loggedInUser: any = [];
    localStorageData: any = [];
    rememberMeObject: any = [];
    rememberMe: any = {};
    roles: any = [];
    growlData: any = {};
    model: any = {};
    showPassword = false;

    constructor(private authenticationService: AuthenticationService, private _myCommunicationService: CommunicationService,
        public utils: UtilsService,
        private router: Router,
        private _zone: NgZone,
        private _cookieService: CookieService,
        private globalEventsManager: GlobalEventsManager,
    ) {
        this.localStorageData = JSON.parse(localStorage.getItem('rememberMe'));
        if (this.localStorageData && this.localStorageData.need) {
            this.model.remember = true;
            this.model.username = this.localStorageData.email;
            this.model.password = this.localStorageData.pd ?
                this.utils.passwordDecryption(this.localStorageData.pd) : this.localStorageData.pd;
        }
    }

    ngOnInit() {
        this.globalEventsManager.showNavBar(false);
        this.globalEventsManager.showSideBar(false);
    }

    login() {
        this.authenticationService.login(this.model.username, this.model.password).subscribe((response: any) => {
            if (this.utils.isResponseSuccess(response)) {
                this.userData = response.responseData;
                if (this.userData) {
                    if (this.userData.roleId.includes(KRONOS.SUPER_ADMIN) || this.userData.roleId.includes(KRONOS.HR)) {
                        const user = response.responseData;
                        const modules = response.responseData.moduleList;
                        delete user.moduleList;
                        this.putCookie('loggedInUser', JSON.stringify(user));
                        this.putCookie('moduleList', JSON.stringify(modules));
                        this.putCookie('Certificate', this.userData.sessionId);
                        if (this.model.remember) {
                            this.rememberMeObject = {
                                'need': true,
                                'email': this.model.username,
                                'pd': this.utils.passwordEncryption(this.model.password),
                                'pid': this.userData.sessionId || 'password'
                            };
                            localStorage.setItem('rememberMe', JSON.stringify(this.rememberMeObject));
                        } else {
                            const rememberMe = localStorage.getItem('rememberMe');
                            if (rememberMe) {
                                localStorage.removeItem('rememberMe');
                            }
                        }
                        this._myCommunicationService.loggedInDataemitChange(JSON.stringify(this.userData));

                        // access based on roles
                        if (this.getCookie('loggedInUser') !== undefined) {
                            this.loggedInUser = JSON.parse(this.getCookie('loggedInUser'));
                        }

                        this.router.navigate([KRONOS.ROUTERLINKS.USERS]);
                    } else {
                        this.growlData = {
                            severity: 'error', summary: KRONOS.MESSAGES.UNAUTHORIZED_CREDENTIALS, detail: '',
                        };
                        this._myCommunicationService.emitChange(this.growlData);
                        this.authenticationService.logout();
                    }
                }

            } else if (response.statusCode === 401) {
                this.growlData = {
                    severity: 'error', summary: KRONOS.MESSAGES.INVALID_CREDENTIALS, detail: ''
                };
                this._myCommunicationService.emitChange(this.growlData);
            }
        });
    }


    putCookie(key: string, value: string) {
        return this._cookieService.put(key, value);
    }

    getCookie(key: string) {
        return this._cookieService.get(key);
    }

    togglePassword() {
        this.showPassword = !this.showPassword;
    }
}
